(function () {
  if (window.__SM_GLOBAL_SMOOTH_SCROLL__) return;
  window.__SM_GLOBAL_SMOOTH_SCROLL__ = true;

  const isTouchDevice =
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    window.matchMedia("(pointer: coarse)").matches;

  if (isTouchDevice) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  let currentY = window.pageYOffset;
  let targetY = currentY;
  let rafId = null;

  const ease = 0.065;
  const wheelStep = 0.9;
  const maxWheelDelta = 140;

  function getMaxScroll() {
    return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function isInsideScrollableElement(element) {
    while (element && element !== document.body) {
      const style = window.getComputedStyle(element);
      const overflowY = style.overflowY;

      const canScroll =
        (overflowY === "auto" || overflowY === "scroll") &&
        element.scrollHeight > element.clientHeight;

      if (canScroll) return true;

      element = element.parentElement;
    }

    return false;
  }

  function animate() {
    const diff = targetY - currentY;
    currentY += diff * ease;

    if (Math.abs(diff) < 0.4) {
      currentY = targetY;
    }

    window.scrollTo(0, currentY);

    if (Math.abs(targetY - currentY) > 0.4) {
      rafId = requestAnimationFrame(animate);
    } else {
      rafId = null;
    }
  }

  function startAnim() {
    if (!rafId) {
      rafId = requestAnimationFrame(animate);
    }
  }

  window.addEventListener(
    "wheel",
    function (e) {
      const activeEl = document.activeElement;

      const isFormField =
        activeEl &&
        (activeEl.tagName === "INPUT" ||
          activeEl.tagName === "TEXTAREA" ||
          activeEl.tagName === "SELECT" ||
          activeEl.isContentEditable);

      if (isFormField) return;

      if (isInsideScrollableElement(e.target)) return;

      const delta = clamp(e.deltaY, -maxWheelDelta, maxWheelDelta);
      targetY = clamp(targetY + delta * wheelStep, 0, getMaxScroll());

      e.preventDefault();
      startAnim();
    },
    { passive: false }
  );

  window.addEventListener(
    "keydown",
    function (e) {
      const activeEl = document.activeElement;

      const isFormField =
        activeEl &&
        (activeEl.tagName === "INPUT" ||
          activeEl.tagName === "TEXTAREA" ||
          activeEl.tagName === "SELECT" ||
          activeEl.isContentEditable);

      if (isFormField) return;

      const max = getMaxScroll();
      let nextTarget = targetY;

      if (e.key === "ArrowDown") nextTarget += 100;
      else if (e.key === "ArrowUp") nextTarget -= 100;
      else if (e.key === "PageDown") nextTarget += window.innerHeight * 0.9;
      else if (e.key === "PageUp") nextTarget -= window.innerHeight * 0.9;
      else if (e.key === "Home") nextTarget = 0;
      else if (e.key === "End") nextTarget = max;
      else return;

      targetY = clamp(nextTarget, 0, max);

      e.preventDefault();
      startAnim();
    },
    { passive: false }
  );

  window.addEventListener("resize", function () {
    currentY = window.pageYOffset;
    targetY = clamp(targetY, 0, getMaxScroll());
  });

  window.addEventListener(
    "scroll",
    function () {
      if (!rafId) {
        currentY = window.pageYOffset;
        targetY = currentY;
      }
    },
    { passive: true }
  );
})();